import React from 'react';
import { 
  FaCar, 
  FaStar, 
  FaUsers, 
  FaShieldAlt, 
  FaClock, 
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaCheckCircle,
  FaAward,
  FaHeart,
  FaLeaf,
  FaSmile,
  FaRocket,
  FaHandshake,
  FaUserTie,
  FaTaxi,
  FaRoad,
  FaCity,
  FaGlobeAsia,
  FaWhatsapp
} from 'react-icons/fa';

import { 
  MdSecurity,
  MdEmojiEvents,
  MdTrendingUp,
  MdOutlineVerified,
  MdOutlineSupportAgent,
  MdOutlineCleanHands,
  MdOutlineSpeed,
  MdOutlineThumbUp,
  MdOutlineGroups,
  MdOutlineLocationOn
} from 'react-icons/md';

import { 
  RiCustomerServiceLine,
  RiHeartLine,
  RiShieldLine,
  RiAwardLine,
  RiTeamLine,
  RiUserStarLine,
  RiMapPinLine,
  RiTimeLine,
  RiCheckboxCircleLine
} from 'react-icons/ri';

const Green = '#000000';      // Fresh Green
const LightGreen = '#E8F5E9';  // Light Green Background
const White = '#FFFFFF';       // Pure White
const Orange = '#000000';      // Vibrant Orange
const LightOrange = '#FFF3E0'; // Light Orange Background
const DarkGreen = '#0c0c0c';   // Dark Green for text/accents
const DarkOrange = '#000000';  // Dark Orange for hover

export default function AboutUs() {
  const stats = [
    { icon: <FaUsers />, value: '100+', label: 'Happy Customers' },
    { icon: <FaCar />, value: '100+', label: 'Fleet of Cars' },
    { icon: <FaStar />, value: '4.4', label: 'Customer Rating' },
    { icon: <FaClock />, value: '24/7', label: 'Service Available' }
  ];

  const features = [
    { icon: <FaShieldAlt />, title: 'Safe Rides', desc: 'GPS tracked vehicles with experienced drivers', color: Green },
    { icon: <RiCustomerServiceLine />, title: '24/7 Support', desc: 'Round-the-clock customer assistance', color: Orange },
    { icon: <FaAward />, title: 'Best Prices', desc: 'Affordable rates with no hidden charges', color: Green },
    { icon: <MdOutlineCleanHands />, title: 'Clean Cars', desc: 'Well-maintained and sanitized vehicles', color: Orange },
    { icon: <FaHandshake />, title: 'Trusted Service', desc: 'Years of experience in cab industry', color: Green },
    { icon: <MdOutlineSpeed />, title: 'On Time', desc: 'Punctual pickups and drops guaranteed', color: Orange }
  ];

  const team = [
    { name: 'Michael Raj', role: 'Founder & CEO', exp: '12+ years', icon: <FaUserTie /> },
    // { name: 'Priya Sharma', role: 'Operations Head', exp: '10+ years', icon: <RiTeamLine /> },
    // { name: 'Rajesh Kumar', role: 'Fleet Manager', exp: '12+ years', icon: <FaTaxi /> },
    // { name: 'Anita Desai', role: 'Customer Support', exp: '8+ years', icon: <RiCustomerServiceLine /> }
  ];

  const milestones = [
    { year: '2026', event: 'Company Founded', desc: 'Started with 5 cars in Chennai' },
    { year: '2026', event: 'Fleet Expansion', desc: 'Grew to 5+ vehicles' },
    { year: '2026', event: 'Digital Launch', desc: 'Launched mobile app & online booking' },
    { year: '2026', event: 'Major Milestone', desc: '100+ happy customers served' },
    { year: '2026', event: 'Today', desc: '100+ fleet, 24/7 service in Chennai' }
  ];

  const values = [
    { icon: <FaHeart />, title: 'Customer First', desc: 'Your satisfaction is our priority', color: Orange },
    { icon: <RiShieldLine />, title: 'Safety First', desc: 'Your security matters to us', color: Green },
    { icon: <FaLeaf />, title: 'Eco-Friendly', desc: 'Going green with every ride', color: Green },
    { icon: <FaSmile />, title: 'Happy Journey', desc: 'Making every ride memorable', color: Orange }
  ];

  return (
    <div className="min-h-screen" style={{ background: LightGreen }}>
      {/* Hero Section with Indian Tricolor Theme */}
      <div style={{ 
        background: ` url('https://upload.wikimedia.org/wikipedia/commons/d/db/Chennai_Central_D.jpg')`,
backgroundBlend: 'overlay',
backgroundSize: 'cover',
backgroundPosition: 'center',
        padding: '80px 20px 100px',
        position: 'relative',
        overflow: 'hidden'
      }}>
        {/* Decorative Elements */}
        {/* <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          opacity: 0.1,
          backgroundImage: 'radial-gradient(circle at 20px 20px, white 2px, transparent 2px)',
          backgroundSize: '40px 40px'
        }} /> */}
        
        <div className="max-w-6xl mx-auto text-center relative z-10">
          <h1 className="text-5xl md:text-6xl font-bold mb-6" style={{ color: DarkGreen }}>
            About <span style={{ color: DarkOrange }}>Safe Track</span> Cab Service
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto" style={{ color: '#333' }}>
            Your Trusted Partner for Safe and Comfortable Rides Across Chennai
          </p>
          
          {/* Stats Grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-4xl mx-auto mt-12">
            {stats.map((stat, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                <div className="text-4xl mb-3" style={{ color: index % 2 === 0 ? Green : Orange }}>
                  {stat.icon}
                </div>
                <div className="text-2xl font-bold" style={{ color: DarkGreen }}>{stat.value}</div>
                <div className="text-sm text-gray-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-6xl mx-auto px-4 py-16">
        
        {/* Our Story Section */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{ color: DarkGreen }}>
              Our <span style={{ color: Orange }}>Journey</span>
            </h2>
            <div className="w-20 h-1 mb-6" style={{ background: `linear-gradient(90deg, ${Green}, ${Orange})` }} />
            <p className="text-lg text-gray-700 mb-4 leading-relaxed">
              Founded in 2026, Safe Track Cab Service has grown from a small fleet of 5 cars to one of Chennai's most trusted cab services. Our journey has been driven by a single mission: to provide safe, reliable, and comfortable transportation to every customer.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Today, with over 100+ vehicles and 100+ happy customers, we continue to uphold our commitment to excellence, safety, and customer satisfaction. Our team of experienced drivers and support staff work 24/7 to ensure you reach your destination safely and on time.
            </p>
            <div className="flex gap-4">
              <div className="flex items-center gap-2">
                <FaCheckCircle className="text-xl" style={{ color: Green }} />
                <span className="font-semibold">ISO Certified</span>
              </div>
              <div className="flex items-center gap-2">
                <FaCheckCircle className="text-xl" style={{ color: Orange }} />
                <span className="font-semibold">Govt Registered</span>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-white rounded-2xl p-6 shadow-lg text-center">
              <div className="text-4xl mb-2" style={{ color: Green }}><FaRocket /></div>
              <div className="font-bold text-xl" style={{ color: DarkGreen }}>2026</div>
              <div className="text-sm text-gray-600">Started Journey</div>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-lg text-center">
              <div className="text-4xl mb-2" style={{ color: Orange }}><FaCity /></div>
              <div className="font-bold text-xl" style={{ color: DarkGreen }}>100+</div>
              <div className="text-sm text-gray-600">City Locations</div>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-lg text-center">
              <div className="text-4xl mb-2" style={{ color: Green }}><FaUsers /></div>
              <div className="font-bold text-xl" style={{ color: DarkGreen }}>100+</div>
              <div className="text-sm text-gray-600">Happy Clients</div>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-lg text-center">
              <div className="text-4xl mb-2" style={{ color: Orange }}><FaGlobeAsia /></div>
              <div className="font-bold text-xl" style={{ color: DarkGreen }}>24/7</div>
              <div className="text-sm text-gray-600">Service</div>
            </div>
          </div>
        </div>

        {/* Milestones Timeline */}
        <div className="mb-20">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" style={{ color: DarkGreen }}>
            Our <span style={{ color: Orange }}>Milestones</span>
          </h2>
          <div className="relative">
            {/* Timeline Line */}
            <div className="absolute left-0 right-0 h-1 top-1/2 transform -translate-y-1/2 hidden md:block" 
                 style={{ background: `linear-gradient(90deg, ${Green}, ${Orange})` }} />
            
            <div className="grid md:grid-cols-5 gap-4">
              {milestones.map((item, index) => (
                <div key={index} className="relative">
                  <div className="bg-white rounded-xl p-4 shadow-lg text-center relative z-10">
                    <div className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-3"
                         style={{ background: index % 2 === 0 ? Green : Orange }}>
                      <span className="text-white font-bold">{item.year}</span>
                    </div>
                    <h3 className="font-bold text-lg mb-1" style={{ color: DarkGreen }}>{item.event}</h3>
                    <p className="text-sm text-gray-600">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Features Grid */}
        <div className="mb-20">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4" style={{ color: DarkGreen }}>
            Why Choose <span style={{ color: Orange }}>Us</span>
          </h2>
          <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
            Experience the difference with our premium cab services designed just for you
          </p>
          
          <div className="grid md:grid-cols-3 gap-6">
            {features.map((feature, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                <div className="text-3xl mb-4" style={{ color: feature.color }}>{feature.icon}</div>
                <h3 className="text-xl font-bold mb-2" style={{ color: DarkGreen }}>{feature.title}</h3>
                <p className="text-gray-600">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Our Values */}
        <div className="mb-20">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" style={{ color: DarkGreen }}>
            Our Core <span style={{ color: Orange }}>Values</span>
          </h2>
          
          <div className="grid md:grid-cols-4 gap-6">
            {values.map((value, index) => (
              <div key={index} className="text-center">
                <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4"
                     style={{ background: LightOrange, color: value.color }}>
                  <span className="text-3xl">{value.icon}</span>
                </div>
                <h3 className="font-bold text-lg mb-2" style={{ color: DarkGreen }}>{value.title}</h3>
                <p className="text-sm text-gray-600">{value.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Team Section */}
        <div className="mb-20">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4" style={{ color: DarkGreen }}>
            Meet Our <span style={{ color: Orange }}>Team</span>
          </h2>
          <p className="text-center text-gray-600 mb-12">Dedicated professionals ensuring your safe journey</p>
          
          <div className="grid md:grid-cols-4 gap-6">
            {team.map((member, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-lg text-center hover:shadow-xl transition-all">
                <div className="w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-4"
                     style={{ background: index % 2 === 0 ? LightGreen : LightOrange }}>
                  <span className="text-4xl" style={{ color: index % 2 === 0 ? Green : Orange }}>{member.icon}</span>
                </div>
                <h3 className="font-bold text-lg mb-1" style={{ color: DarkGreen }}>{member.name}</h3>
                <p className="text-sm font-medium" style={{ color: Orange }}>{member.role}</p>
                <p className="text-xs text-gray-500 mt-2">{member.exp} experience</p>
              </div>
            ))}
          </div>
        </div>

        {/* Contact CTA */}
        <div className="rounded-3xl p-12 text-center" style={{ 
          background: `linear-gradient(135deg, ${Green}20 0%, ${White} 50%, ${Orange}20 100%)`,
          border: `2px solid ${Orange}30`
        }}>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: DarkGreen }}>
            Ready to <span style={{ color: Orange }}>Ride</span> With Us?
          </h2>
          <p className="text-lg text-gray-700 mb-8 max-w-2xl mx-auto">
            Experience the safest and most comfortable rides in Chennai. Book your cab now!
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a href="tel:+919150410309" className="inline-flex items-center gap-2 px-8 py-3 rounded-full text-white font-semibold hover:shadow-lg transition-all transform hover:-translate-y-1"
               style={{ background: Green }}>
              <FaPhone /> Call Now
            </a>
            <a href="https://wa.me/919150410309" className="inline-flex items-center gap-2 px-8 py-3 rounded-full text-white font-semibold hover:shadow-lg transition-all transform hover:-translate-y-1"
               style={{ background: Green }}>
              <FaWhatsapp /> WhatsApp Us
            </a>
          </div>
        </div>
      </div>

      {/* Footer */}
     
    </div>
  );
}